export default "__VITE_ASSET__1e5b7d31__"